var _mask, _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashNavyBlueWithYellowX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5293_2187",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06662 3.5H12.8444V12.0001C12.8444 13.1047 11.949 14.0001 10.8444 14.0001H3.06662C1.96205 14.0001 1.06662 13.1047 1.06662 12.0001V3.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.06662 3.5H12.8444V12.0001C12.8444 13.1047 11.949 14.0001 10.8444 14.0001H3.06662C1.96205 14.0001 1.06662 13.1047 1.06662 12.0001V3.5Z",
    fill: "#1F2445",
    stroke: "#1F2445",
    strokeWidth: 8,
    mask: "url(#path-1-inside-1_5293_2187)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.875H14V2.625H0V0.875Z",
    fill: "#1F2445"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49206 0.478285C3.67375 0.181181 3.99692 0 4.34518 0H9.5658C9.91405 0 10.2372 0.181181 10.4189 0.478285L11.0777 1.55556H2.83327L3.49206 0.478285Z",
    fill: "#1F2445"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.87801,
    height: 1.97006,
    transform: "matrix(0.708752 -0.705458 0.718986 0.695024 3.5 10.8457)",
    fill: "#F2B90D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.87525,
    height: 1.97075,
    transform: "matrix(-0.695805 -0.718231 0.731492 -0.68185 9.01938 12.25)",
    fill: "#F2B90D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashNavyBlueWithYellowX);
export default __webpack_public_path__ + "static/media/trashNavyBlueWithYellowX.7033416895453232b678e1d28933f757.svg";
export { ForwardRef as ReactComponent };